import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  
  Loader2,

  ChevronDown,
  Download,
 
  Trash2,
  ArrowLeftRight,
  Pencil,
  Hash,
  Phone,
  Calendar,
  BadgeDollarSign,
  FileText,
  User2,
 
} from "lucide-react";

import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { apiFetch } from "@/lib/api";
import { RowActionMenu } from "@/components/RowActionMenu";

/** Helpers */
function safe(v: any, fallback = "-") {
  if (v === null || v === undefined || v === "") return fallback;
  return String(v);
}
function nf(v: any) {
  if (v === null || v === undefined || v === "") return "-";
  const n = Number(v);
  return Number.isFinite(n) ? n.toLocaleString() : String(v);
}




type PaymentRow = {
  id?: number | string;
  loan_id?: number | string;
  transaction_amount?: number | string;
  phone_number?: string;
  transaction_code?: string;
  mpesa_payer?: string;
  created_at?: string;
  CREATEDBY?: string;
};

type PaginationMeta = {
  current_page: number;
  per_page: number;
  total: number;
  last_page: number;
  has_more: boolean;
};



export default function ActiveLoanPaymentsTab({ customerId }: { customerId: string }) {
const perPage = 10;
 const location = useLocation();
  const nonce = (location.state as any)?.nonce;
     const onDownloadAll = () => alert("TODO: download all loans/payments");
  const onDownloadPayments = () => alert("TODO: download payments");
  const onReassignPayment = (p: PaymentRow) => alert(`TODO: reassign payment ${p.id ?? ""}`);
  const onDeletePayment = (p: PaymentRow) =>
    confirm("Delete this payment?") && alert(`TODO: delete payment ${p.id ?? ""}`);
const [err, setErr] = useState("");

  /** paginated payments */
  const [payments, setPayments] = useState<PaymentRow[]>([]);
  const [paymentsLoading, setPaymentsLoading] = useState(false);
  const [paymentsMeta, setPaymentsMeta] = useState<PaginationMeta | null>(null);
  const [paymentsPage, setPaymentsPage] = useState(1);

  async function fetchPayments(page = 1) {
    if (!customerId) return;
    if (paymentsLoading) return;

    setPaymentsLoading(true);
    try {
      const res = await apiFetch<any>(`/customer-profile/${customerId}/payments?page=${page}&per_page=${perPage}`);
      const rows: PaymentRow[] = res?.data?.data ?? res?.data ?? [];
      const meta: PaginationMeta | null = res?.data?.meta ?? null;

      setPayments(rows); // page-style pagination (replace)
      setPaymentsMeta(meta);
      setPaymentsPage(page);
    } catch (e: any) {
      setErr(e?.message || "Failed to load payments");
    } finally {
      setPaymentsLoading(false);
    }
  }

   const paymentsTotal = useMemo(
    () => payments.reduce((sum, x) => sum + (Number(x.transaction_amount) || 0), 0),
    [payments]
  );
  useEffect(() => {
    fetchPayments()
    }, [nonce]);

    
    const dir = (document.documentElement.getAttribute("dir") as "ltr" | "rtl") || "ltr";
    const isRTL = dir === "rtl";
return (
    <>
        {/* Desktop */}
        <div className="hidden lg:block overflow-x-auto rounded-xl border">
            <table className="min-w-[980px] w-full text-sm">
                <thead className="bg-muted/50">
                    <tr className="text-left">
                        <th className="p-3">#</th>
                        <th className="p-3">LOAN ID</th>
                        <th className="p-3">Amount</th>
                        <th className="p-3">Phone Number</th>
                        <th className="p-3">Reference</th>
                        <th className="p-3">Mpesa Payer</th>
                        <th className="p-3">Created on</th>
                        <th className="p-3">Created By</th>
                        <th className="p-3">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {paymentsLoading ? (
                        <tr>
                            <td className="p-6 text-muted-foreground" colSpan={9}>
                                <div className="flex items-center gap-2">
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                    Loading payments...
                                </div>
                            </td>
                        </tr>
                    ) : payments.length ? (
                        <>
                            {payments.map((p, idx) => (
                                <tr key={String(p.id ?? idx)} className="border-t">
                                    <td className="p-3">{idx + 1}</td>
                                    <td className="p-3">{safe(p.loan_id)}</td>
                                    <td className="p-3">{nf(p.transaction_amount)}</td>
                                    <td className="p-3">{safe(p.phone_number)}</td>
                                    <td className="p-3">{safe(p.transaction_code)}</td>
                                    <td className="p-3">{safe(p.mpesa_payer)}</td>
                                    <td className="p-3">{safe(p.created_at)}</td>
                                    <td className="p-3">{safe(p.CREATEDBY)}</td>
                                    <td className="p-3">
                                         <RowActionMenu
                isRTL={isRTL}
               
              />
                                    </td>
                                </tr>
                            ))}

                            <tr className="border-t bg-muted/30">
                                <td className="p-3 font-semibold" colSpan={2}>
                                    Total
                                </td>
                                <td className="p-3 font-semibold">{nf(paymentsTotal)}</td>
                                <td className="p-3" colSpan={6} />
                            </tr>
                        </>
                    ) : (
                        <tr>
                            <td className="p-4 text-muted-foreground" colSpan={9}>
                                No payments yet.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>

        {/* Mobile */}
      {/* Mobile */}
<div className="lg:hidden space-y-3">
  {paymentsLoading ? (
    <Card className="shadow-card">
      <CardContent className="p-4 text-sm text-muted-foreground flex items-center gap-2">
        <Loader2 className="h-4 w-4 animate-spin" />
        Loading payments...
      </CardContent>
    </Card>
  ) : payments.length ? (
    <>
      {payments.map((p, idx) => (
        <Card
          key={String(p.id ?? idx)}
          className="shadow-card rounded-2xl border bg-background hover:shadow-md transition-shadow"
        >
          <CardContent className="p-4 space-y-3">
            {/* Header */}
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <div className="h-9 w-9 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                    <User2 className="h-4 w-4" />
                  </div>

                  <div className="min-w-0">
                    <div className="font-semibold truncate">
                      {safe(p.mpesa_payer, "Mpesa Payment")}
                    </div>
                    <div className="text-xs text-muted-foreground flex items-center gap-1 min-w-0">
                      <FileText className="h-3.5 w-3.5 text-primary" />
                      <span className="truncate">
                        Ref: <span className="text-foreground font-semibold">{safe(p.transaction_code)}</span>
                      </span>
                    </div>
                  </div>
                </div>

                {/* Meta row */}
                <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
                  <MiniMeta icon={Hash} label="Loan ID" value={safe(p.loan_id)} />
                  <MiniMeta icon={Phone} label="Phone" value={safe(p.phone_number)} />
                  <MiniMeta icon={Calendar} label="Created" value={safe(p.created_at)} />
                  <MiniMeta icon={BadgeDollarSign} label="Amount" value={nf(p.transaction_amount)} />
                </div>
              </div>

              {/* Action menu */}
              <RowActionMenu
                isRTL={isRTL}
               
              />
            </div>

            {/* Quick actions (optional) */}
            <div className="flex gap-2 pt-1">
              <Button size="sm" onClick={() => onReassignPayment(p)} className="flex-1 gap-2">
                <ArrowLeftRight className="h-4 w-4" />
                Reassign
              </Button>

              <Button
                size="sm"
                variant="destructive"
                onClick={() => onDeletePayment(p)}
                className="flex-1 gap-2"
              >
                <Trash2 className="h-4 w-4" />
                Delete
              </Button>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>
                By: <span className="text-foreground font-semibold">{safe(p.CREATEDBY)}</span>
              </span>
              <span className="inline-flex items-center gap-1">
                <Pencil className="h-3.5 w-3.5 text-primary" />
                Payment #{safe(p.id)}
              </span>
            </div>
          </CardContent>
        </Card>
      ))}

      <Card className="shadow-card">
        <CardContent className="p-3 flex items-center justify-between">
          <div className="text-sm font-semibold">Total</div>
          <div className="text-sm font-semibold">{nf(paymentsTotal)}</div>
        </CardContent>
      </Card>
    </>
  ) : (
    <div className="text-sm text-muted-foreground">No payments yet.</div>
  )}
</div>

        {/* Pagination (payments) */}
        <div className="mt-2 flex items-center justify-between gap-2 flex-wrap">
            <div className="text-xs text-muted-foreground">
                {paymentsMeta ? (
                    <>
                        Page {paymentsMeta.current_page} of {paymentsMeta.last_page} • Total {paymentsMeta.total}
                    </>
                ) : null}
            </div>

            <div className="flex items-center gap-2 flex-wrap">
                <Button variant="outline" disabled={paymentsLoading || paymentsPage <= 1} onClick={() => fetchPayments(Math.max(1, paymentsPage - 1))}>
                    Prev
                </Button>

                <Button
                    variant="outline"
                    disabled={paymentsLoading || !(paymentsMeta?.has_more ?? false)}
                    onClick={() => fetchPayments(paymentsPage + 1)}
                    className="gap-2"
                >
                    {paymentsLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
                    Next
                </Button>

                <Button variant="secondary" disabled={paymentsLoading} onClick={() => fetchPayments(1)} className="gap-2">
                    {paymentsLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
                    Refresh
                </Button>

                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button className="gap-2" onClick={onDownloadPayments}>
                            <Download className="h-4 w-4" />
                            Download
                            <ChevronDown className="h-4 w-4" />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="start">
                        <DropdownMenuItem onClick={() => alert("TODO: download payments PDF")}>PDF</DropdownMenuItem>
                        <DropdownMenuItem onClick={() => alert("TODO: download payments Excel")}>Excel</DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </div>
        </div>
    </>
);
function MiniMeta({
  icon: Icon,
  label,
  value,
}: {
  icon: any;
  label: string;
  value: string;
}) {
  return (
    <div className="rounded-xl border bg-muted/20 p-3">
      <div className="flex items-center gap-2">
        <div className="h-8 w-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center">
          <Icon className="h-4 w-4" />
        </div>
        <div className="min-w-0">
          <div className="text-[11px] text-muted-foreground font-medium">{label}</div>
          <div className="text-sm font-semibold truncate">{value}</div>
        </div>
      </div>
    </div>
  );
}
}